<template>
    <div>
        <div class="title-menu"> Banks</div>

        <div class="wrap-filter">
            <div class="btn-add" @click="showModalAdd()"> Tambah </div>
        </div>

        <div class="wrap-table">
            <table class="table table-striped table-hover table-borderless">
                <thead >
                    <tr style="height: 23px">
                        <th scope="col" class="text-center" >Kode Bank</th>
                        <th scope="col" class="text-left">Nama Bank</th>
                        <th scope="col" class="text-center" style="width:20%">Logo</th>
                        <th colspan="2" class="text-center" style="width:30%">Aksi</th> 
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data_res,index) in data" :key="index">
                        <td class="text-center">{{data_res.bank_code}}</td>
                        <td scope="row">{{data_res.name}} </td>
                        
                        <td class="text-center"> 
                           <div class="text-center btn-detail" @click="showModalLogo(data_res)"> Lihat Logo  </div> 
                        </td>

                        <td class="text-center">
                            <div class="text-center btn-detail" @click="showModalDetail(data_res)"> Lihat Detail </div>
                        </td>
                        
                        <td class="text-center">
                            <div class="text-center btn-edit" @click="showModalEdit(data_res)"> Ubah </div>
                        </td>
                    
                    </tr>

                </tbody>
            </table>
        </div>

        <b-modal ref="my-modal-view" hide-footer hide-header title="lihat logo">
            <div class="wrap-modal-view">
                <div class="row">
                        <img :src= base_img+data_modal.logo class="img-doc-view" v-if="data_modal">
                        <img src="" class="img-doc-view" v-else>
                </div>
                <span class="close-modal" @click="hideModalLogo"> X </span>
            </div>
        </b-modal>

        <b-modal ref="my-modal-detail" hide-footer hide-header title="lihat detail">
            <div class="wrap-modal-view">
                <div class="title-modal mb-5"> Detail Bank</div>

                    <div class="row">
                        <div class="col-4">
                            <label for="name" class="label-modal"> Kode Bank</label>
                        </div>

                        <div class="col-8">
                            <label for="name" class="label-modal bold">{{data_modal.bank_code}}</label>
                        </div>
                    </div>

                     <div class="row">
                        <div class="col-4">
                            <label for="name" class="label-modal"> Nama</label>
                        </div>

                        <div class="col-8">
                            <label for="name" class="label-modal bold">{{data_modal.name}}</label>
                        </div>
                    </div>

                    <!-- <div class="row">
                        <div class="col-4">
                            <label for="name" class="label-modal"> Tipe future</label>
                        </div>

                        <div class="col-8">
                            <ul v-for="(data,index) in data_modal.futures_type" :key="index">
                                <li class="list-data-modal"> {{data.name}}</li>
                            </ul>
                        </div>
                    </div> -->

                     <div class="row">
                        <div class="col-4">
                            <label for="name" class="label-modal"> Jenis Bank</label>
                        </div>

                        <div class="col-8">
                            <label for="name" class="label-modal bold">{{data_modal.is_syariah ? 'Syariah' : 'Konvensional'}}</label>
                        </div>
                    </div>

                     <div class="row">
                        <div class="col-4">
                            <label for="name" class="label-modal"> Status Bank</label>
                        </div>

                        <div class="col-8">
                            <label for="name" class="label-modal bold">{{data_modal.is_publish ? 'Aktif' : 'Tidak Aktif'}}</label>
                        </div>
                    </div>

                     <div class="row">
                        <div class="col-4">
                            <label for="name" class="label-modal"> Status Trading</label>
                        </div>

                        <div class="col-8">
                            <label for="name" class="label-modal bold">{{data_modal.is_trading ? 'Tersedia' : 'Tidak Tersedia'}}</label>
                        </div>
                    </div>

                    <div class="text-right mt-5">
                        <div class="btn-cancel-modal mr-3" @click="hideModalDetail"> Tutup</div>
                    </div>
            </div>
        </b-modal>

        <b-modal ref="my-modal-edit" hide-footer hide-header title="edit">
            <div class="wrap-modal-view">
                <div class="title-modal mb-3"> Ubah Bank</div>
                
                <form @submit.prevent="edit">
                    <label for="name" class="label-modal"> Nama</label>
                    <input type="text" v-model="form_edit.name" id="name" class="form-modal mb-3">
                    
                    <div class="row">
                        <div class="col">
                            <label for="product_code" class="label-modal"> Kode Produk</label>
                            <input type="text" v-model="form_edit.product_code" id="product_code" class="form-modal mb-3">
                        </div>
                        <div class="col">
                            <label for="" class="label-modal"> Tipe Bank</label>
                            <select class="slc-pcg" v-model="form_edit.is_syariah">
                                <option value="" selected disabled> Pilih Bank </option>
                                <option value="true"> Syariah </option>
                                <option value="false"> Konvensional </option>
                            </select>
                        </div>
                    </div>
    
                    <div class="row mb-3">
                        <div class="col">
                            <label for="code_bank" class="label-modal"> Kode Bank</label>
                            <input type="text" v-model="form_edit.bank_code" id="code_bank" class="form-modal mb-3">
                        </div>

                        <div class="col">
                            <label for="type_rek" class="label-modal"> Tipe</label>
                            <input type="text" v-model="form_edit.type" id="type_rek" class="form-modal mb-3">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col">
                            <label for="code_bank" class="label-modal"> Status</label>
                            <select class="slc-pcg" v-model="form_edit.is_publish">
                                <option value="" selected disabled> Pilih Status </option>
                                <option value="true"> Aktif </option>
                                <option value="false"> Tidak Aktif </option>
                            </select>
                        </div>

                        <div class="col">
                            <label for="" class="label-modal"> Tersedia dalam Trading</label>
                            <select class="slc-pcg" v-model="form_edit.is_trading">
                                <option value="" selected disabled> Pilih Tipe </option>
                                <option value="true"> Iya </option>
                                <option value="false"> Tidak </option>
                            </select>
                        </div>
                    </div>

                    <div class="text-right mt-3">
                        <div class="btn-cancel-modal mr-3" @click="hideModalEdit"> Tutup</div>
                        <button class="btn-edit-modal" type="submit"> Ubah </button>
                    </div>
                
                </form>
            </div>
        </b-modal>

        <b-modal ref="my-modal-add" hide-footer hide-header title="add">
            <div class="wrap-modal-view">
                <div class="title-modal mb-3"> Tambah Bank</div>
                
                <form enctype="multipart/form-data" @submit.prevent="add">
                    <label for="name" class="label-modal"> Nama</label>
                    <input type="text" v-model="form.name" id="name" class="form-modal mb-3">
                    
                    <div class="row">
                        <div class="col">
                            <label for="product_code" class="label-modal"> Kode Produk</label>
                            <input type="text" v-model="form.product_code" id="product_code" class="form-modal mb-3">
                        </div>
                        <div class="col">
                            <label for="" class="label-modal"> Tipe Bank</label>
                            <select class="slc-pcg" v-model="form.is_syariah">
                                <option value="" selected disabled> Pilih Bank </option>
                                <option value="true"> Syariah </option>
                                <option value="false"> Konvensional </option>
                            </select>
                        </div>
                    </div>
    
                    <div class="row mb-3">
                        <div class="col">
                            <label for="code_bank" class="label-modal"> Kode Bank</label>
                            <input type="text" v-model="form.bank_code" id="code_bank" class="form-modal mb-3">
                        </div>

                        <div class="col">
                            <label for="type_rek" class="label-modal"> Tipe</label>
                            <input type="text" v-model="form.type" id="type_rek" class="form-modal mb-3">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col">
                            <label for="code_bank" class="label-modal"> Status</label>
                            <select class="slc-pcg" v-model="form.is_publish">
                                <option value="" selected disabled> Pilih Status </option>
                                <option value="true"> Aktif </option>
                                <option value="false"> Tidak Aktif </option>
                            </select>
                        </div>

                        <div class="col">
                            <label for="" class="label-modal"> Tersedia dalam Trading</label>
                            <select class="slc-pcg" v-model="form.is_trading">
                                <option value="" selected disabled> Pilih Tipe </option>
                                <option value="true"> Iya </option>
                                <option value="false"> Tidak </option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <!-- <label for="" class="label-modal"> Pilih Future</label>
                            <b-form-checkbox-group
                                v-model="form.futures_type"
                                :options="options"
                                name="flavour-2a"
                                stacked
                            ></b-form-checkbox-group> -->
                        </div>

                        <div class="col">
                            <!-- <label class="label-modal bold mb-2"> Logo </label> 
                            <div class="wrap-img-city"> 
                                <input type="file" id="foto" @input="addLogo($event.target.files[0])" class="input-form-foto-modal" hidden>
                                <label for="foto"> 
                                    <img src="/assets/default.png" class="detail-foto-modal">
                                </label>
                            </div> -->
                        </div>
                    </div>

                    <div class="text-right mt-3">
                        <div class="btn-cancel-modal mr-3" @click="hideModalAdd"> Tutup</div>
                        <button class="btn-edit-modal" type="submit"> Tambah </button>
                    </div>
                
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'Banks',
    data() {
        return{
            data:'',
            futures:'',
            data_modal:'',
            id_:'',
            options:[],
            options_edit:[],
            form_edit: {
                name:'',
                product_code:'',
                type:'',
                bank_code:'',
                is_syariah:'',
                is_publish:'',
                is_trading:'',
                // futures_type:[],
                // logo:''
            },
            form: {
                name:'',
                product_code:'',
                type:'',
                bank_code:'',
                is_syariah:'',
                is_publish:'',
                is_trading:'',
                // futures_type:[],
                // logo:''
            },

            base_img: process.env.VUE_APP_URL_IMG,

        }
    },
    
    methods: {

        showModalDetail(data) {
            this.$refs['my-modal-detail'].show()

            this.data_modal = data
        },

        hideModalDetail() {
            this.$refs['my-modal-detail'].hide()
        },

        showModalLogo(data) {
            this.$refs['my-modal-view'].show()
            this.data_modal = data
        },

        hideModalLogo() {
            this.$refs['my-modal-view'].hide()
        },

        showModalEdit(data) {
            // console.log(data)

            this.$refs['my-modal-edit'].show()
            this.form_edit.name = data.name
            this.form_edit.product_code = data.product_code
            this.form_edit.type = data.type
            this.form_edit.bank_code = data.bank_code
            this.form_edit.is_publish = data.is_publish
            this.form_edit.is_trading = data.is_trading
            this.form_edit.is_syariah = data.is_syariah
            // this.form_edit.logo = data.logo
            this.id_ = data._id
            // for( let i=0; i < data.futures_type.length; i++) {
            //     this.form_edit.futures_type[i] = data.futures_type[i]._id
            // }

        },

        hideModalEdit() {
            this.$refs['my-modal-edit'].hide()
        },

        editLogo(data) {
            this.form_edit.logo = data
        },

        async edit() {
            // let fd = new FormData()
            
            // fd.append('name', this.form_edit.name)
            // fd.append('is_publish', this.form_edit.is_publish)
            // fd.append('is_trading', this.form_edit.is_trading)
            // fd.append('logo', this.form_edit.logo)

            // if(this.form_edit.futures_type) {
            //     for(let i = 0; i < this.form_edit.futures_type.length; i++) {
            //     let type = this.form_edit.futures_type[i]

            //     fd.append('futures_type[' + [i] + ']', type)
            //     }
            // }

            try {
                const hit = await axios.put('v1/admin/bank/'+this.id_, this.form_edit)
                console.log(hit)

                if(!hit.data.iserror) {
                    window.location.href = '/banks' 
                }
            } 
            catch(e) {

            }
        },

        showModalAdd() {
            this.$refs['my-modal-add'].show()
        },

        hideModalAdd() {
            this.$refs['my-modal-add'].hide()
        },

        addLogo(data) {
            console.log(data)
            this.form.logo = data
        },

        async add() {
            console.log(this.form)
            // let fd = new FormData()
            
            // fd.append('name', this.form.name)
            // fd.append('is_syariah', this.form.is_syariah)
            // fd.append('bank_code', this.form.bank_code)
            // fd.append('is_publish', this.form.is_publish)
            // fd.append('logo', this.form.logo)
            // fd.append('is_trading', this.form.is_trading)

            // if(this.form.futures_type) {
            //     for(let i = 0; i < this.form.futures_type.length; i++) {
            //     let type = this.form.futures_type[i]

            //     fd.append('futures_type[' + [i] + ']', type)
            //     }
            // }
            

            try {
                const hit = await axios.post('/v1/admin/bank', this.form)
                console.log(hit)

                // if(!hit.data.iserror) {
                //     window.location.href = '/banks' 
                // }
            } 
            catch(e) {

            }
        }
    },

    async mounted() {

// data banks
        try {
            const res = await axios.get('/v1/admin/bank')
            this.data = res.data.data.bank
            console.log(res)
        } 
        catch(e) {

        }

// data futures
        try {
            const res = await axios.get('/v1/admin/futures_trading')
            this.futures = res.data.data
            for(let future of res.data.data) {
                this.options.push( 
                    {
                        text: future.name,
                        value: future._id
                    }
                )

                this.options_edit.push( 
                    {
                        text: future.name,
                        value: future._id
                    }
                )
            }
            console.log(res)
        } 
        catch(e) {

        }
        
    }
}
</script>

<style scoped>

tr td {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #000000;
}

.list-data-modal {
    margin-left: 17px;
    font-size: 14px;
    font-weight: 600;
    list-style: inherit;
    padding-left: 5px;
}

.view-logo {
    /* background: rgba(0, 155, 60, 0.1); */
    border-radius: 5px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #009B3C;
    cursor: pointer;
    padding: 10px;
}

.btn-edit {
    background: #FF6F00;
    border-radius: 3px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    color: #FFFFFF;
    padding: 10px;
    cursor: pointer;
}

.title-menu {
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    /* line-height: 49px; */
    color: #292b3f;
    margin-bottom: 45px;
}

.wrap-filter {
    border-radius: 5px;
    padding: 15px 25px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.wrap-table {
    border-radius: 5px;
    padding: 15px 25px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    margin-top: 50px;
}

.t-pcg {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: -0.26px;
    text-align: left;
    color: #292b3f;
    display: inline-block;
    margin-right: 10px;
}

.slc-pcg {
  padding: 5px 10px;
  width: 172px;
  height: 36px;
  border-radius: 5px;
  border: solid 1px #f4f3f9;
  background-color: #f4f3f9;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #292b3f;
  font-size: 13px;
  margin-right: 10px;
}
</style>